import { render } from "./RevisaoRelatorio.vue?vue&type=template&id=1cdf34b4&scoped=true"
import script from "./RevisaoRelatorio.vue?vue&type=script&lang=js"
export * from "./RevisaoRelatorio.vue?vue&type=script&lang=js"

import "./RevisaoRelatorio.vue?vue&type=style&index=0&id=1cdf34b4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdf34b4"]])

export default __exports__